export const mainFormUpdateMS = 50;
export const formUpdateMS = 100;
